<template>
  <div v-if="!loading" class="pc-mode">
    <site-header/>
    <div class="container">
      <article>
        <div class="message-container">
          <div class="message">
            指定されたページは存在しません。<br/>
            恐れ入りますが、<router-link id="to_top" :to="{ name: 'SiteTop' }">トップページ</router-link>からお探しください。
          </div>
        </div>
      </article>
    </div>
    <site-footer/>
  </div>
</template>

<script>
import SiteHeader from '@/components/pc/SiteHeader'
import SiteFooter from '@/components/pc/SiteFooter'
import { mapState } from 'vuex'
export default {
  name: 'PageNotFound',
  components: {
    SiteHeader,
    SiteFooter
  },
  created () {
    this.$store.commit('loading/setStatus', false)
  },
  computed: {
    ...mapState('loading', {
      loading: state => state.status
    })
  }
}
</script>

<style lang="scss" scoped>
@import '../../css/variables';
header {
  line-height: 90px;
  border-bottom: 1px solid #e6e6e6 !important;
  .title {
    color: $primary;
  }
}
#delay {
  text-decoration: none;
  font-size: 23px;
  margin-left: 23px;
  font-weight: 600;
}
.message a {
    text-decoration: underline;
}
.message-container {
  display: table;
  width: 100%;
  .message {
    height: 500px;
    font-weight: 600;
    text-align: center;
    display: table-cell;
    vertical-align: middle;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pc/PageNotFound.vue